import { store } from "@/vuex/store.js";

export function closeInfoSidebar() {
    if (store?.state?.info_sidebar?.info_sidebar) {
        store.dispatch("info_sidebar/setInfoSidebar");
        store.dispatch("info_sidebar/setInfoSidebarObject", {});
        store.dispatch("info_sidebar/setInfoSidebarCategory", "");
    }
}

export function clearGeneralFilter() {
    if (store?.state?.general_filter?.generalFilter) {
        store.dispatch("general_filter/applyGeneralFilter", null);
    }
}


// WEBPACK FOOTER //
// ./src/utils/router_middleware.js